module.exports = [
  'en',
  'ja',
  'es',
  'de',
  'it',
  'fr',
  'nl',
  'hu',
  'no',
  'el',
  'da',
  'ro',
  'fi',
  'sv',
  'pt',
  'pl',
  'zh-Hant',
  'zh-Hans',
];
